import { STOREFRONT } from '@/lib/utils/translation';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import Link from 'next/link';

type CitiesCardProps = {
  cityThumbUrl: string;
  cityName: string;
  countPlaces: number;
  citySlug: string;
  places: string;
};

const OnlineShopCard = (props: CitiesCardProps) => {
  const { cityThumbUrl, cityName, countPlaces, citySlug } = props;
  const t = useTranslations();
  return (
    <Link
      href={`${citySlug}`}
      className="cities-card group relative inline-block h-[350px] w-full overflow-hidden rounded-[20px] md:max-w-[600px] lg:h-[300px] lg:max-w-[450px] xl:max-w-[590px]"
    >
      <div className="relative h-full w-full overflow-hidden">
        <Image
          src={cityThumbUrl}
          alt={
            cityName +
            ' ' +
            countPlaces +
            ' ' +
            (countPlaces > 1
              ? t(STOREFRONT.HOME + '.cities.gastrnomies')
              : t(STOREFRONT.HOME + '.cities.gastrnomy'))
          }
          className="object-cover transition-all duration-500 ease-linear group-hover:scale-125"
          fill
        />
      </div>
      <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-30" />
      <div className="absolute bottom-[25px] left-[30px] right-[30px] z-[30]">
        <h3 className="mb-[5px] text-h5 font-bold text-white">{cityName}</h3>
        <span className="text-sm text-white">
          {countPlaces}{' '}
          {countPlaces > 1
            ? t(STOREFRONT.HOME + '.cities.gastrnomies')
            : t(STOREFRONT.HOME + '.cities.gastrnomy')}
        </span>
      </div>
    </Link>
  );
};

export default OnlineShopCard;
